import { motion } from 'motion/react'

import { EASE } from './constants'

const PULSE_SECONDS = 1.9

const RING_SPREAD = 9

type Props = {
  /** Off once there is nothing left to report — a settled screen holds still. */
  animates: boolean
  tone?: 'primary' | 'error'
}

const shadow = (spread: number, alpha: number, tone: string) =>
  `0 0 0 ${spread}px color-mix(in srgb, ${tone} ${alpha}%, transparent)`

/**
 * Live indicator beside the build phase. The halo is a box-shadow rather than a
 * second element, so the dot keeps its own size in the flex row it sits in.
 */
export const PulseDot = ({ animates, tone = 'primary' }: Props) => {
  const color =
    tone === 'error' ? 'var(--ant-color-error)' : 'var(--ant-color-primary)'

  return (
    <motion.span
      animate={
        animates
          ? { boxShadow: [shadow(0, 22, color), shadow(RING_SPREAD, 0, color)] }
          : undefined
      }
      transition={
        animates
          ? { duration: PULSE_SECONDS, repeat: Infinity, ease: EASE }
          : undefined
      }
      style={{
        width: 6,
        height: 6,
        borderRadius: 999,
        background: color,
        flex: 'none'
      }}
    />
  )
}
